import React, { useState, useEffect, useContext, useMemo } from 'react';
import GlobalContext from '../../contexts/global.js';
import StateContext from '../../contexts/state.js';
import Listing from '../../components/Listing.js';
import PageBanner from '../../components/PageBanner.js';
import { changeBrowserTitle } from '../../hooks/headAmender.js';
import useTemporaryLos from '../../hooks/useTemporaryLos.js';
import locationBadgeIcon from '../../helpers/locationBadgeIcon.js';
import categoryFilterGroup from '../../helpers/categoryFilterGroup.js';

const FirmwideNews = () => {
    const { globalContext } = useContext(GlobalContext);
    const { updateState } = useContext(StateContext);

    const [search, setSearch] = useState("");
    const [selectedCategories, setSelectedCategories] = useState([]);

    useTemporaryLos("all");

    changeBrowserTitle(`Firmwide news${ globalContext?.siteConfig?.siteName ? ` - ${ globalContext.siteConfig.siteName }` : "" }`);

    const filterGroups = useMemo(() => ([
        [{ key: "firmwide", value: "true" }],
        ...categoryFilterGroup(selectedCategories)
    ]), [selectedCategories]);

    useEffect(() => {
        updateState({
            banner: (
                <PageBanner
                    crumbLabel="Firmwide news"
                    title="Firmwide news"
                    description="A roundup of announcements, updates and stories from across the firm."
                    icon="globe"
                    search={search}
                    searchPlaceholder="Search news"
                    onSearchChange={setSearch}
                    selectedCategories={selectedCategories}
                    onCategoriesChange={setSelectedCategories}
                />
            )
        });

        return () => {
            updateState({ banner: null });
        }
    }, [search, selectedCategories]);

    return (
        <section>
            <Listing
                filterGroups={filterGroups}
                search={search}
                initialCount={6}
                paginateBy={6}
                groupByDate={true}
                badgeKeys={[
                    { key: "los", icon: "people" },
                    { key: "location", icon: locationBadgeIcon }
                ]}
            />
        </section>
    );
};

export default FirmwideNews;
